import { FC, useRef, useState } from "react";

import CheckIcon from "@mui/icons-material/Check";
import ReplayIcon from "@mui/icons-material/Replay";
import { Button } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid/models";

import { ProviderRegistrationService } from "~/services";

const ContactProvider: FC<GridRenderCellParams | { providerRegistrationId?: string }> = (props) => {
  const providerRegistrationId = "row" in props ? props.row.registration.providerRegistrationId : props.providerRegistrationId;

  const [isLoading, setIsLoading] = useState(false);
  const [isContacted, setIsContacted] = useState(false);
  const [hasError, setHasError] = useState(false);

  const abortController = useRef<AbortController>(new AbortController());

  const handleContactProvider = async () => {
    setIsLoading(true);

    try {
      if (abortController.current) {
        abortController.current.abort();
        abortController.current = new AbortController();
      }

      const contactResult = await ProviderRegistrationService.contactProvider(providerRegistrationId, abortController.current?.signal);

      if (contactResult?.status !== 204) {
        throw new Error();
      }
      setIsContacted(true);
    } catch {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      disabled={isContacted}
      loading={isLoading}
      loadingPosition="start"
      onClick={(e) => {
        e.stopPropagation();
        handleContactProvider();
      }}
      size="small"
      startIcon={isContacted ? <CheckIcon /> : hasError ? <ReplayIcon /> : undefined}
    >
      {hasError ? "Retry" : isContacted ? "Contacted" : "Contact"}
    </Button>
  );
};

export default ContactProvider;
